// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bpYY","name":"styles_name__1XqaE","phone":"styles_phone__3Sl8p"};